import { PaymentElement } from '@stripe/react-stripe-js';
import { useFormikContext } from 'formik';
import { CheckboxField } from '~/components/checkbox';
import { Box } from '~/components/layout';
import { PageNonprofit } from '~/types/graphql';
import { DONOR_COVER_FEES_TOOLTIP, DonorCoverFeesLabel } from '../../DonorCoverFeesLabel';

import IconInfo from '../../assets/icon-info.svg';
import { Values } from '../../hooks/use-form';
import { PaymentMethod } from '../../types';
import { FormSection } from '../form-section';
import { InfoTooltip } from '../tooltip';
import IconCard from './assets/card-icon.svg';

type Props = {
  donorCoversFees: boolean
  nonprofit: PageNonprofit
  isTicketPurchase?: boolean
  onPaymentMethodChange: (paymentMethod: PaymentMethod) => void
}

export const BillingDetails = ({
  donorCoversFees,
  isTicketPurchase,
  onPaymentMethodChange,
}: Props) => {
  const { setFieldValue, values } = useFormikContext<Values>()

  return (
    <FormSection icon={<IconCard />} heading="Method of Payment">
      <PaymentElement
        id="payment-element"
        onChange={(e: any) => {
          const method =
            e.value.type == 'us_bank_account'
              ? PaymentMethod.Ach
              : e.value.type == 'card'
              ? PaymentMethod.Card
              : PaymentMethod.Other
          onPaymentMethodChange(method)
          setFieldValue('paymentMethod', method)
        }}
        options={{
          layout: 'tabs',
        }}
      />

      {donorCoversFees ? (
        <Box display={'flex'} alignItems={'flex-start'} marginTop={28}>
          <CheckboxField
            alignTop
            marginRight={'0.5rem'}
            label={
              <DonorCoverFeesLabel
                fee={values.orderCalculation.withCoveringFees.fee}
                isTicketPurchase={isTicketPurchase}
              >
                <InfoTooltip
                  tooltipText={DONOR_COVER_FEES_TOOLTIP}
                >
                  <IconInfo />
                </InfoTooltip>
              </DonorCoverFeesLabel>
            }
            name="coverProcessingFees"
          />
        </Box>
      ) : (
        <></>
      )}
    </FormSection>
  )
}
